<template>
    <fullscreen-modal v-if="open" :close="close">
        <div class="video-modal-container" v-if="videoOpen">
            <div class="video-title" v-html="videoOpen.title"></div>
            <div class="video-embed">
                <iframe width="480" height="270" :src="`//www.youtube.com/embed/${videoOpen.id}?autoplay=1`" frameborder="0" allowfullscreen=""></iframe>
            </div>
            <div class="video-description" v-html="videoOpen.description"></div>
        </div>
    </fullscreen-modal>
</template>

<script>
    import FullscreenModal from "./fullscreen-modal.vue";
    export default {
    	components: {
			FullscreenModal
        },
        props: [
        	"open",
            "close",
            "videoOpen"
        ]
    }
</script>

<style lang="scss">
    @import "~foundation-sites/scss/foundation";
    .video-modal-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        @include breakpoint(medium) {
            width: 70%;
        }
        @include breakpoint(large) {
            max-width: 1290px;
        }
        height: calc(100vh - 3rem);
        flex-wrap: wrap;
        margin: 0 auto;
    }
    .video-title,
    .video-description {
        color: white;
        margin-right: 1rem;
        width: 100%;
        background: rgba(255, 255, 255, 0.18);
        border-radius: 5px;
        padding: .5rem;
        margin-bottom: 1rem;
    }
    .video-title {
        font-size: 1.3rem;
    }
    .video-description {
        white-space: pre-wrap;
        text-align: left;
    }
    .video-embed {
        width: 100%;
        height: 0;
        padding-top: calc(9 / 16 * 100%);
        margin-right: 1rem;
        position: relative;
        margin-bottom: 1rem;
    }
    .video-embed > iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// video-modal.vue?4bb4652b